<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Copyright</h1>
</div>
</div>
<h1 class="head">
	Copyright</h1>
<div class="halftitle">
<div class="copy_block">
<p class="center">
			Diversion Books</p>
<p class="center">
			A Division of Diversion Publishing Corp.</p>
<p class="center">
			443 Park Avenue South, Suite 1004</p>
<p class="center">
			New York, NY 10016</p>
<p class="center">
<a href="http://www.diversionbooks.com" target="_blank">www.DiversionBooks.com</a></p>
</div>
<div class="copy_block">
<p class="center">
			Copyright © 1989 by Anita Mills</p>
</div>
<div class="copy_block">
<p class="center">
			All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.</p>
</div>
<div class="copy_block">
<p class="center">
			For more information, email <a href="http://info@diversionbooks.com" target="_blank">info@diversionbooks.com</a>.</p>
<p class="center">
			First Diversion Books edition May 2013.</p>
<p class="center">
			ISBN: 9781626810471</p>
<p class="center">
</p>
<div style="page-break-after: always;">
<div style="display: none;">
</div>
</div>
<p>
</p>
</div>
</div>
<p style="text-align: center;">
<em><strong>Also by Anita Mills</strong> </em></p>
<p style="text-align: center;">
<span href="#/chap153559" title="Link target outside of Sample">Duel of Hearts</span></p>
<p style="text-align: center;">
<span href="#/chap153559" title="Link target outside of Sample">Devil’s Match</span></p>
<p style="text-align: center;">
<span href="#/chap153559" title="Link target outside of Sample">Scandal Bound</span></p>
<p style="text-align: center;">
<span href="#/chap153559" title="Link target outside of Sample">Follow the Heart</span></p>
<p style="text-align: center;">
<span href="#/chap153559" title="Link target outside of Sample">Secret Nights</span></p>
<p style="text-align: center;">
<span href="#/chap153559" title="Link target outside of Sample">Bittersweet</span></p>
<p style="text-align: center;">
<span href="#/chap153559" title="Link target outside of Sample">The Rogue’s Return</span></p>
<p style="text-align: center;">
<span href="#/chap153559" title="Link target outside of Sample">Autumn Rain</span></p>
<p style="text-align: center;">
<span href="#/chap153559" title="Link target outside of Sample">Miss Gordon’s Mistake</span></p>
<p style="text-align: center;">
<span href="#/chap153559" title="Link target outside of Sample">Dangerous</span></p>
<p class="first_small_top" style="text-align: center;">
</p>
<p style="text-align: center;">
<strong>The Fire Series</strong></p>
<p style="text-align: center;">
<span href="#/chap153559" title="Link target outside of Sample">Lady of Fire</span></p>
<p style="text-align: center;">
<span href="#/chap153559" title="Link target outside of Sample">Fire and Steel</span></p>
<p style="text-align: center;">
<span href="#/chap153559" title="Link target outside of Sample">Hearts of Fire</span></p>
<p style="text-align: center;">
<span href="#/chap153559" title="Link target outside of Sample">The Fire and the Fury</span></p>
<p style="text-align: center;">
<span href="#/chap153559" title="Link target outside of Sample">Winter Roses</span></p>
<p>
</p>
<p>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap139625.vue?d9fd49f2